import { Text } from '@chakra-ui/react';

interface ITextBlockProps {
  children: string;
}

export const TextBlock: React.FC<ITextBlockProps> = (props): JSX.Element => {
  const { children } = props;
  return (
    <Text fontSize={{ base: 'h3.base', md: 'h2.md' }} fontWeight="normal" textAlign="center">
      {children}
    </Text>
  );
};
